// Reset password pages — shopify sends a URL to the user with a complicated path
import { useRouter } from 'next/router'

import fetcher from '@lib/fetcher'
import customerResetMutation from '@lib/mutations/customer-reset'

import ResetPassword from '@components/profile/SignIn/ResetPassword'

interface IFormInput {
	password: string
	signInError: string
	passwordConfirm: string
	errorOther?: string
}

export default function ResetPasswordScreen() {
	const router = useRouter()
	// Submit reset password
	const onSubmit = async (data: IFormInput) => {
		const { customerResetByUrl } = await fetcher({
			query: customerResetMutation,
			variables: {
				resetUrl: router.query.reset_url,
				password: data.password
			}
		})

		return customerResetByUrl as { customerUserErrors: any[] }
	}

	return <ResetPassword onSubmit={onSubmit} />
}
